import { redirect } from '@tanstack/react-router'

import { hasAdminGroupAccess } from '@/auth/adminAccess'
import { getEntraAuthorizeUrl } from '@/auth/entraConfig'
import { hasValidEntraAccessToken } from '@/data/api/token'
import { useAuthStore } from '@/store/authStore'

/**
 * Admin routes are always protected. Unauthenticated / expired users go to Entra authorize.
 */
export const requireAuthentication = async () => {
  const { isAuthenticated } = useAuthStore.getState()

  if (isAuthenticated && hasValidEntraAccessToken()) {
    return
  }

  window.location.assign(await getEntraAuthorizeUrl())
  await new Promise<never>(() => undefined)
}

/** Documents / Web pages — only for users whose JWT includes the admin Entra group. */
export const requireAdminAccess = async () => {
  await requireAuthentication()

  if (!hasAdminGroupAccess()) {
    throw redirect({ to: '/' })
  }
}
